import PdfProductPageFull from 'components/Export/Pages/PdfProductPageFull';
import { ListProduct } from 'microshop-api';
import { PdfSettingStakeholder } from '../exportPdfTypes';
import { PdfPageWithFooter } from './PdfPageWithFooter';

type Props = {
    products: ListProduct[];
    showVariationImages?: boolean;
    showImagePicture?: boolean;
    seller?: PdfSettingStakeholder;
    orderNumber?: string | null;
};

export const PdfProductsPageFull = ({
    products,
    showVariationImages = false,
    showImagePicture = true,
    seller,
    orderNumber,
}: Props) => {
    if (!products.length) return null;

    return (
        <PdfPageWithFooter seller={seller} orderNumber={orderNumber}>
            {products.map((p, index) => (
                <PdfProductPageFull
                    newPage={index !== 0}
                    key={index}
                    product={p}
                    showVariationImages={showVariationImages}
                    showImagePicture={showImagePicture}
                />
            ))}
        </PdfPageWithFooter>
    );
};

export default PdfProductsPageFull;
